import { run } from "formula";

const evalFormula = (formula: string, context = {}) => run(formula, context);

export default evalFormula;
